import { render, staticRenderFns } from "./ApiLogs.vue?vue&type=template&id=32287cbc&"
import script from "./ApiLogs.vue?vue&type=script&lang=js&"
export * from "./ApiLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports